export default {
  setting: {},
  labels: {},
  statusList: []
}
